import { Locations } from "01Data/02User/Locations";
import {
  NotificationItem,
  User,
  UserNotification,
  UserNotificationFlag,
} from "01Data/Account";
import { appData } from "01Data/AppData";
import { BuildingInfo, Pico3, Sensor } from "01Data/DataTypes";

export class ProcessNotificationSettingPage {
  public loginUser: User = new User(null);
  public users: User[] = [];
  public selectedUser: User = new User();
  public selectedDevice: NotificationItem = new NotificationItem();
  public locations: Locations = new Locations();
  // データ
  public listData: UserNotification[] = [];

  public Clear() {
    this.loginUser = new User(null);
    this.users = [];
    this.selectedUser = new User();
    this.selectedDevice = new NotificationItem();
    this.listData = [];
  }

  public async Load() {
    const id = await appData.account.GetLoginUserId();
    this.users = await User.GetUsers();
    this.loginUser =
      this.users.find((user: User) => user.UserId === id) ?? new User(null);
    // // ログインユーザを取り除く
    // this.users = this.users.filter(
    //   (user: User) => user.UserId !== this.loginUser.UserId,
    // );
    // 通知情報を取得
    const promises = this.users.map((user: User) => user.GetDetails());
    await Promise.allSettled(promises);
    await this.locations.GetLocationAndDeviceData();
    // データ構築
    this.listData = this.users.map((user: User) => new UserNotification(user));
    this.listData.forEach((user: UserNotification) => {
      this.locations.locations.forEach((building: BuildingInfo) => {
        if (
          user.user.LinkBuildings.find(
            (id: string) => id === building.BuildingId
          )
        ) {
          // リンクしている建物についてデバイス一覧を構築
          this.BuildNotificationList(user, building);
        }
      });
    });
  }

  private BuildNotificationList(
    user: UserNotification,
    building: BuildingInfo
  ) {
    const sensors = this.locations.sensors.filter(
      (sensor: Sensor) => sensor.BuildingId === building.BuildingId
    );
    const sensorItems = sensors.map((sensor: Sensor) => {
      const flags = this.GetFlags(sensor.SensorId, user, building);
      return new NotificationItem(
        "sensor",
        sensor.SensorName,
        building.BuildingName,
        sensor.LocationName,
        flags
      );
    });
    const pico3 = this.locations.pico3.filter(
      (pico3: Pico3) => pico3.BuildingId === building.BuildingId
    );
    const pico3Items = pico3.map((pico3: Pico3) => {
      const flags = this.GetFlags(pico3.PicoId, user, building);
      return new NotificationItem(
        "pico3",
        pico3.PicoName,
        building.BuildingName,
        pico3.LocationName,
        flags
      );
    });
    user.items.push(...sensorItems);
    user.items.push(...pico3Items);
  }

  private GetFlags(id: string, user: UserNotification, building: BuildingInfo) {
    return (
      user.user.SensorSettings.find(
        (item: UserNotificationFlag) =>
          item.BuildingId === building.BuildingId && id === item.SensorId
      ) ??
      new UserNotificationFlag({
        DisplayFlg: "false",
        SensorId: id,
        MailFlg: "false",
        BuildingId: building.BuildingId,
      })
    );
  }
}
